import React, { useEffect } from "react";
import { Button } from "@my-scoot/component-library-legacy";
import { useHistory, useLocation } from "react-router-dom";
import { useListController } from "react-admin";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import { dataProvider } from "data";
import Loading from "./Loading";

import { useStyles } from "./styles";
import { useDispatch } from "react-redux";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { orgPermissions, RESOURCE_KEYS } from "utils/OrgPermissions";
import {
  EXLY_GLOBAL__CUSTOM_BACK_NAVIGATION,
  EXLY_GLOBAL__SET_PAGE_TITLE,
  EXLY_GLOBAL__SET_SHOW_APP_BAR,
  EXLY_GLOBAL__SET_SHOW_BOTTOM_NAV,
} from "redux/actions";

import {
  whatsappCampaignStatusChoices,
  whatsappTabsMapping,
} from "./constants";
import { InitialSegmentUsedWA } from "./item/components/InitialSegmentUsedWA";
import { getParamValueFromRouteProps, getParameterByName } from "utils/Utils";
import { RESET_TEMPLATE_VALUES } from "../redux/actions";
import { useWhatsAppHelpers } from "../useWhatsAppHelpers";
import { whatsapp_broadcasts_apis } from "../whatsappBroadCast.api";
import { app_route_ids, app_route_keys } from "constants/urlPaths";
import {
  STATUS,
  WHATSAPP_BROADCASTS_LEARN_MORE_HREFS,
} from "../whatsappBroadcast.constants";
import { whatsappListProps } from "./BroadCastList";
import { getWhatsappWhiteLabelData } from "../whatsappBroadcastStorageUtils";
import { Header } from "common/Components/Header";
import moduleStyles from "./WhatsappListLayout.module.css";
import useAppLayoutControl from "hooks/useAppLayoutControl";
import { useToggleState } from "utils/hooks";
import { CreateCustomTemplateModal } from "../modules/CreateCustomTemplateModal/CreateCustomTemplateModal";
import { logError } from "utils/error";
import { AI_SENSY_WABA_STATUS } from "features/Integration/modules/WhatsappStepper/constants/WhatsappStepper.constants";
import { WAStats } from "./module/WAStats/WAStats";

//Refractored code and moved to layout, most of the code is old code from index.js
const WhatsappListLayout = ({ tabValue, props, children }) => {
  const isDesktop = useDesktopMediaQuery();
  const history = useHistory();
  const location = useLocation();

  const currentSubTab =
    Number(getParameterByName(STATUS, location?.search)) ||
    whatsappCampaignStatusChoices.Completed;

  const isBroadcastTab =
    !tabValue || tabValue === whatsappTabsMapping.broadcast;
  const isBroadcastHistoryTab =
    isBroadcastTab && currentSubTab === whatsappCampaignStatusChoices.Completed;

  const { loading } = useListController(whatsappListProps);
  const [showInitialSegmentModal, setShowInitialSegmentModal] =
    React.useState(false);
  const [
    isCreateCustomTemplateModalOpen,
    openCreateCustomTemplateModal,
    closeCreateCustomTemplateModal,
  ] = useToggleState(false);

  const styles = useStyles({ isDesktop });

  const hasWriteAccess = orgPermissions.hasFeatureWriteAccess(
    RESOURCE_KEYS.SECTIONS.WHATSAPP_BROADCASTS
  );
  const canReadSegments = !orgPermissions.isNavigationItemHidden(
    RESOURCE_KEYS.SECTIONS.SEGMENTATION
  );

  const whatsappWhiteLabelData = getWhatsappWhiteLabelData();
  const { checkIsAiSensyBlockedAfterEnabling } = useWhatsAppHelpers();

  const disableWhatsappBroadCastCreation =
    !hasWriteAccess ||
    checkIsAiSensyBlockedAfterEnabling(whatsappWhiteLabelData);

  const dispatch = useDispatch();
  const checkSegment = getParamValueFromRouteProps(props, "check_segment");

  const handleCreate = () => {
    dispatch({ type: RESET_TEMPLATE_VALUES });
    history.push("/whatsapp-broadcasts/select");
  };

  React.useEffect(() => {
    if (checkSegment && canReadSegments) {
      setShowInitialSegmentModal(true);
    }
  }, []);

  useAppLayoutControl({
    values: {
      learnMoreHref: WHATSAPP_BROADCASTS_LEARN_MORE_HREFS.WHATSAPP_BROADCASTS,
    },
  });

  useEffect(() => {
    dispatch({
      type: EXLY_GLOBAL__SET_PAGE_TITLE,
      payload: "WhatsApp Broadcast",
    });
    dispatch({
      type: EXLY_GLOBAL__CUSTOM_BACK_NAVIGATION,
      payload: () => {
        history.replace(`${app_route_ids[[app_route_keys.sales_marketing]]}`);
      },
    });
    dispatch({ type: EXLY_GLOBAL__SET_SHOW_APP_BAR, payload: isDesktop });
    dispatch({ type: EXLY_GLOBAL__SET_SHOW_BOTTOM_NAV, payload: false });

    return () => {
      dispatch({ type: EXLY_GLOBAL__SET_PAGE_TITLE, payload: "" });
      dispatch({ type: EXLY_GLOBAL__SET_SHOW_APP_BAR, payload: true });
      dispatch({ type: EXLY_GLOBAL__SET_SHOW_BOTTOM_NAV, payload: true });
    };
  }, [dispatch, isDesktop]);

  useEffect(() => {
    try {
      // This is to prompt the back-end to sync campaign stats via whatsapp webhooks
      dataProvider.custom_request(
        whatsapp_broadcasts_apis.sync_campaign,
        "POST"
      );
    } catch (error) {
      logError({
        error,
        when: "Error in post campaign web hook",
        occuredAt: "src/ui/pages/whatsappBroadcast/list/WhatsappListLayout.jsx",
      });
    }
  }, []);

  const isWhatsappWhitelabeled =
    whatsappWhiteLabelData?.wa_waba_connect_status ==
    AI_SENSY_WABA_STATUS.APPROVED;

  return (
    <div className={`component-wrapper ${styles.root}`}>
      {isDesktop ? (
        <Header
          title="WhatsApp Marketing"
          learnMoreHref={
            WHATSAPP_BROADCASTS_LEARN_MORE_HREFS.WHATSAPP_BROADCASTS
          }
          about="about creating and managing Whatsapp Broadcasts."
          right={
            <div className="d-flex">
              <Button
                size="large"
                color="secondary"
                onClick={openCreateCustomTemplateModal}
                disabled={!hasWriteAccess || disableWhatsappBroadCastCreation}
                className="mr-3"
              >
                Create Custom Template
              </Button>
              <Button
                className={styles.createButton}
                size="large"
                color="primary"
                onClick={handleCreate}
                disabled={disableWhatsappBroadCastCreation}
              >
                Create WhatsApp Broadcast
              </Button>
            </div>
          }
          classNames={{ container: moduleStyles.headerContainer }}
          hideBackButton
        />
      ) : (
        <div className={styles.header}>
          <div className={styles.createButtonContainer}>
            {isDesktop ? undefined : (
              <>
                {tabValue === whatsappTabsMapping.broadcast ? (
                  <Button
                    className={styles.createButton}
                    size="large"
                    color="primary"
                    fullWidth
                    onClick={handleCreate}
                    disabled={disableWhatsappBroadCastCreation}
                  >
                    Create WhatsApp Broadcast
                  </Button>
                ) : (
                  <Button
                    size="large"
                    color="primary"
                    fullWidth
                    onClick={openCreateCustomTemplateModal}
                    disabled={
                      !hasWriteAccess || disableWhatsappBroadCastCreation
                    }
                  >
                    Create Custom Template
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {isBroadcastHistoryTab && <WAStats />}

      <div className={styles.subHeader}>
        The Broadcast feature allows you to send a message to several contacts
        at once.
      </div>

      {loading ? <Loading isDesktop={isDesktop} /> : <>{children}</>}

      {showInitialSegmentModal ? <InitialSegmentUsedWA /> : null}

      <CreateCustomTemplateModal
        open={isCreateCustomTemplateModalOpen}
        onClose={closeCreateCustomTemplateModal}
        isWhatsappWhitelabeled={isWhatsappWhitelabeled}
      />
    </div>
  );
};

export default withComponentLibraryTheme(WhatsappListLayout);
